var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"flat":_vm.flat,"color":_vm.color,"data-qa":("" + _vm.dataQaPrefix + (_vm.dashify(this.item[this.rowKey])))},on:{"click":_vm.action}},[_vm._v(" "+_vm._s(_vm.buttonText)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }